import $ from 'jquery';
import 'jquery-selectric/src/jquery.selectric';

// Keep plugin available on global jQuery used by non-bundled scripts.
if (window.jQuery && window.jQuery.fn && $.fn && $.fn.selectric && !window.jQuery.fn.selectric) {
    window.jQuery.fn.selectric = $.fn.selectric;
}

if (window.$ && window.$.fn && $.fn && $.fn.selectric && !window.$.fn.selectric) {
    window.$.fn.selectric = $.fn.selectric;
}

window.$ = window.$ || $;
window.jQuery = window.jQuery || $;

const initSelectric = () => {
    // Target all select elements you want to style
    const selects = document.querySelectorAll('.selectric');
    if (selects.length === 0) return;

    if (!$.fn || typeof $.fn.selectric !== 'function') {
        return;
    }

    $(selects).selectric({
        nativeOnMobile: false, // Always use custom UI
        disableOnMobile: false, // Never disable on mobile
        onInit: function() {
            // Add ARIA attributes for accessibility
            $(this).attr('aria-label', $(this).attr('aria-label') || $(this).attr('name') || 'Dropdown');
        },
        onChange: function() {
            var selectEl = this && this.element ? this.element : this;
            if (selectEl && typeof selectEl.dispatchEvent === 'function') {
                selectEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
        },
        onOpen: function() {
            // Add class to parent .resource_list__filter_left_field
            var $select = $(this);
            var $parent = $select.closest('.resource_list__filter_left_field');
            $parent.addClass('dropdown-open');
        },
        onClose: function() {
            // Remove class from parent .resource_list__filter_left_field
            var $select = $(this);
            var $parent = $select.closest('.resource_list__filter_left_field');
            $parent.removeClass('dropdown-open');
        },
        optionsItemBuilder: function(itemData, element, index) {
            // Add role and aria-selected for accessibility
            return '<span role="option" aria-selected="' + (element.selected ? 'true' : 'false') + '">' + itemData.text + '</span>';
        },
        labelBuilder: function(currItem) {
            // Add role for accessibility
            return '<span role="text">' + currItem.text + '</span>';
        }
    });
};

export default initSelectric;
